module.exports = __webpack_public_path__ + "img/视频封面26.20f2f161.png";